import Lookup from 'src/componentes/select2';

const MinimoEMaximo = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/MinimoEMaximoLookup"
      {...props}
    />
  );
};

export default MinimoEMaximo;
